/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  HideAgentMcpServerRequestBody,
  HideAgentMcpServerRequestBody$Outbound,
  HideAgentMcpServerRequestBody$outboundSchema,
} from "../components/hideagentmcpserverrequestbody.js";

export type HideAgentMcpServerSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type HideAgentMcpServerRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Email address of the enrolled user, sent in the Gram-User-Email header. Required when authenticating with an org-scoped agent install key; ignored for a per-user key, whose owner is the enrolled user.
   */
  gramUserEmail?: string | undefined;
  hideAgentMcpServerRequestBody: HideAgentMcpServerRequestBody;
};

/** @internal */
export type HideAgentMcpServerSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const HideAgentMcpServerSecurity$outboundSchema: z.ZodMiniType<
  HideAgentMcpServerSecurity$Outbound,
  HideAgentMcpServerSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function hideAgentMcpServerSecurityToJSON(
  hideAgentMcpServerSecurity: HideAgentMcpServerSecurity,
): string {
  return JSON.stringify(
    HideAgentMcpServerSecurity$outboundSchema.parse(hideAgentMcpServerSecurity),
  );
}

/** @internal */
export type HideAgentMcpServerRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-User-Email"?: string | undefined;
  HideAgentMcpServerRequestBody: HideAgentMcpServerRequestBody$Outbound;
};

/** @internal */
export const HideAgentMcpServerRequest$outboundSchema: z.ZodMiniType<
  HideAgentMcpServerRequest$Outbound,
  HideAgentMcpServerRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramUserEmail: z.optional(z.string()),
    hideAgentMcpServerRequestBody: HideAgentMcpServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramUserEmail: "Gram-User-Email",
      hideAgentMcpServerRequestBody: "HideAgentMcpServerRequestBody",
    });
  }),
);

export function hideAgentMcpServerRequestToJSON(
  hideAgentMcpServerRequest: HideAgentMcpServerRequest,
): string {
  return JSON.stringify(
    HideAgentMcpServerRequest$outboundSchema.parse(hideAgentMcpServerRequest),
  );
}
